export default {
  listaPrevisaDemandaDomestica: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    direcao: '',
    order: 'codigoProcesso',
    produto: '',
    unidadeMedida: '',
    pesoBruto: '',
    nomeCliente: '',
    referenciaTrust: '',
    dataChegada: '',
    codigoProcesso: '',
  },
  headers: [
    {
      value: 'dataChegada',
      i18n: 'dataChegada',
      text: '',
      filterable: true,
      filterComponent: 'DateFilter',
    },
    {
      value: 'portoDestino',
      i18n: 'portoDestino',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'nomeCliente',
      i18n: 'cliente',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'segmentoProduto',
      i18n: 'segmentoProduto',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'produto',
      i18n: 'produto',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'tipoCarga',
      i18n: 'tipoCarga',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'tipoContainer',
      i18n: 'tipoContainer',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'container',
      i18n: 'container',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'quantidadeContainers',
      i18n: 'quantidadeContainers',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'pesoBruto',
      i18n: 'pesoBruto',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'valorProcesso',
      i18n: 'valorProcesso',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'referenciaTrust',
      i18n: 'referenciaTrust',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
  ],
};
